var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "21px",
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5C326338-AA11-44AA-BE2D-5C2D4EFACDED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SitePges",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SummarizationPage",
    transform: "translate(-858.000000, -478.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(374.000000, 464.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(448.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-drive",
    transform: "translate(36.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.888,13.264 L8.224,0 L15.7813333,0 L23.4506667,13.2586667 L15.888,13.2586667 L15.888,13.264 Z M9.44533333,14.368 L5.66933333,21.0026667 L20.224,21.0026667 L24,14.368 L9.44533333,14.368 Z M7.22133333,1.65866667 L0,14.368 L3.776,21.0026667 L11.1093333,8.288 L7.22133333,1.65866667 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisk);
export default __webpack_public_path__ + "static/media/disk.e890975b04dde19db72e538944193223.svg";
export { ForwardRef as ReactComponent };